// extracted by mini-css-extract-plugin
export default {"direction":"Detail_direction__nnM6q","collaboration":"Detail_collaboration__vJxd9"};